export { default } from './CardAverageTicket'


// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardAverageTicket/index.js